import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../../components/Headers/Header";
import { HiOutlineArrowLongRight } from "react-icons/hi2";
import { getPreviewText } from "../../../util/util";
import { getLatestBlogs } from "../../../lib/fetchBlogs";

const NewsSection = () => {
  const [newsCards, setNewsCards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      setError(null);
      try {
        console.log('Fetching latest blogs...');
        const blogs = await getLatestBlogs();
        console.log('Fetched blogs:', blogs);
        
        if (blogs && blogs.length > 0) {
          const formattedBlogs = blogs.map((blog) => ({
            id: blog._id,
            slug: blog.slug?.current || "",
            image: blog.mainImage?.asset?.url || "",
            headline: blog.title,
            date: new Date(blog.publishedAt).toLocaleDateString("en-GB", { 
              day: '2-digit', 
              month: 'short', 
              year: 'numeric' 
            }),
            content: blog.excerpt || getPreviewText(blog.body || '', 100),
          }));
          setNewsCards(formattedBlogs);
        } else {
          console.log('No blogs found');
          setNewsCards([]);
        }
      } catch (error) {
        console.error("Failed to fetch blogs:", error);
        setError(error.message || 'Failed to load latest news');
        setNewsCards([]);
      } finally {
        setIsLoading(false);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="news-block">
      <Header
        headerTitle="Latest News and Perspectives"
        headerContent="Discover the latest news and insights from Belsoft Systems."
      />
      <div className="news-body">
        <div className="container">
          {isLoading ? (
            <div className="flex justify-center items-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : error ? (
            <div className="text-center py-12">
              <p className="text-red-500">Error: {error}</p>
              <button 
                onClick={() => window.location.reload()}
                className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
              >
                Retry
              </button>
            </div>
          ) : newsCards.length > 0 ? (
            <div className="news-card-container">
              {newsCards.map((news) => (
                <div key={news.id} className="news-card">
                  {news.image && (
                    <img 
                      className="news-image"
                      src={news.image} 
                      alt={news.headline || 'Blog post image'}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  )}
                  <div className="news-content">
                    <h4>{news.headline || 'Untitled Post'}</h4>
                    {news.date && <span>{news.date}</span>}
                    {news.content && <p>{news.content}</p>}
                    {news.slug && (
                      <Link to={`/blog/${news.slug}`}>
                        <div className="word-button">
                          <p>Read more</p>
                          <HiOutlineArrowLongRight />
                        </div>
                      </Link>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-gray-500">No blog posts available at the moment. Please check back later.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};



export default NewsSection;
